/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexampleblurbackgroundprompt4Inputs */

const en_refineexampleblurbackgroundprompt4 = /** @type {(inputs: Refineexampleblurbackgroundprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blur the background softly and keep the subject sharp`)
};

const de_refineexampleblurbackgroundprompt4 = /** @type {(inputs: Refineexampleblurbackgroundprompt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeichne den Hintergrund sanft unscharf und halte das Motiv scharf`)
};

/**
* | output |
* | --- |
* | "Blur the background softly and keep the subject sharp" |
*
* @param {Refineexampleblurbackgroundprompt4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexampleblurbackgroundprompt4 = /** @type {((inputs?: Refineexampleblurbackgroundprompt4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexampleblurbackgroundprompt4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexampleblurbackgroundprompt4(inputs)
	return de_refineexampleblurbackgroundprompt4(inputs)
});
export { refineexampleblurbackgroundprompt4 as "refineExampleBlurBackgroundPrompt" }